import { useState } from 'react';
import { Link } from 'react-router-dom';
import DBadge from './DBadge';
import { IconBookmark } from './Icons';
import styles from './CampaignCard.module.css';

export function calcDday(recruitEnd, status) {
  if (status === 'COMPLETED') return -1;
  if (!recruitEnd) return null;
  return Math.ceil((new Date(recruitEnd) - new Date()) / (1000 * 60 * 60 * 24));
}

/** sections API는 dDay, 목록 API는 recruitEnd만 준다. */
export function resolveDday(campaign) {
  const given = campaign.dday ?? campaign.dDay;
  if (given !== undefined && given !== null) return given;
  return calcDday(campaign.recruitEnd, campaign.status);
}

/** sections API는 thumbnailUrl, 목록 API는 images[0] 또는 imageUrl. */
export function resolveThumbnail(campaign) {
  return campaign.thumbnailUrl ?? campaign.images?.[0] ?? campaign.imageUrl ?? null;
}

/**
 * 원본 이미지 URL.
 * CDN은 thumb300(240×300)과 원본(800×1000) 두 가지만 제공하는데,
 * 히어로는 672×380으로 그려지므로 thumb300을 쓰면 2.8배 확대돼 뭉갠다.
 * 화면에 한 장뿐이라 원본(약 90KB)을 받는 편이 낫다. 카드는 장수가 많아 그대로 둔다.
 */
export function resolveFullImage(campaign) {
  return resolveThumbnail(campaign)?.replace('/thumb300/', '/') ?? null;
}

export default function CampaignCard({ campaign, onBookmark, isScrapped = false }) {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  const { id, title, brandName, recruitCount, status } = campaign;
  const thumbnail = resolveThumbnail(campaign);
  const dday = resolveDday(campaign);
  const showImage = Boolean(thumbnail) && !failed;
  const isClosed = status === 'COMPLETED' || (dday !== null && dday < 0);

  return (
    <div className={styles.card}>
      <div className={`${styles.thumb}${isClosed ? ` ${styles.thumbClosed}` : ''}`}>
        {showImage ? (
          <img
            className={`${styles.thumbImg}${loaded ? ` ${styles.thumbImgLoaded}` : ''}`}
            src={thumbnail}
            alt={title}
            loading="lazy"
            decoding="async"
            onLoad={() => setLoaded(true)}
            onError={() => setFailed(true)}
          />
        ) : (
          <div className={styles.thumbFallback} />
        )}
        {dday !== null && <DBadge dday={dday} />}
        <button
          className={styles.bmBtn}
          onClick={(e) => { e.stopPropagation(); onBookmark(id); }}
          aria-label={isScrapped ? '저장 취소' : '저장'}
        >
          <IconBookmark size={19} filled={isScrapped} />
        </button>
      </div>

      <div className={styles.info}>
        {brandName && <p className={styles.brand}>{brandName}</p>}
        <Link className={styles.name} to={`/campaign/${id}`}>{title}</Link>
        <p className={styles.recruit}>
          <strong>{recruitCount ?? 0}명</strong> 모집
        </p>
      </div>
    </div>
  );
}
